<table mat-table matSort [dataSource]="appointments" class="appointment-table">
    <ng-container matColumnDef="appointment">
        <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
        <td mat-cell *matCellDef="let appointment">
            <app-agenda-appointment-row [appointment]="appointment" [show]="show"></app-agenda-appointment-row>
        </td>
    </ng-container>
    <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
